import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "test"
 * @id: 403643
 */
export default class Group extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.id = opts['@id'] || null;
    this.name = opts['@COMMON_NAME'] || null;
  }
}
